import React from 'react';
import ContactButton from "./ContactButton.jsx";

const SectionContact = () => {
  const address = "г. Наро-Фоминск, ул. Полубоярова, д. 8";
  const hours = "Пн–Пт — с 10:00 до 18:00 По предварительной записи";
  const phone = "+7 (916) 332-82-59";
  const email = "laptshka@mail.ru";

  // Ссылка на Яндекс.Карты с меткой
  const mapUrl = `https://yandex.ru/map-widget/v1/?um=constructor%3A24383e5fef3eb202182448857e820b7220435b7a6b329e172c869b30e07846a4&amp;source=constructor`;
  <script type="text/javascript" charSet="utf-8" async
          src="https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3A24383e5fef3eb202182448857e820b7220435b7a6b329e172c869b30e07846a4&amp;width=500&amp;height=305&amp;lang=ru_RU&amp;scroll=true"></script>
  return (

    <section id="contacts" className="py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="container  mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(100px,373px)_1fr] gap-7 items-start">

          {/* Левая колонка: Контакты */}
          <div className="space-y-8 max-w-[373px]">
            <h2 className="h2 md:text-4xl font-bold tracking-wide">
              Контакты
            </h2>

            <address className="not-italic space-y-4 text3 text-gray-300">
              <p>
                <span className="block font-medium text-white">Адрес:</span>
                {address}
              </p>

              <p>
                <span className="block font-medium text-white">Время работы:</span>
                {hours}
              </p>
            </address>

            <div className="space-y-4 text3">
              <p className="flex items-center gap-3">
                <span className="text-white">Phone</span>
                <a
                  href={`tel:${phone.replace(/[^+\d]/g, '')}`}
                  className="coursor-pointer "
                >
                  {phone}
                </a>
              </p>

              <p className="flex items-center gap-3">
                <span className="text-white">Email</span>
                <a
                  href={`mailto:${email}`}
                  className="coursor-pointer"
                >
                  {email}
                </a>
              </p>
            </div>


          </div>

          {/* Правая колонка: Карта */}
          <div className="relative">
            <div className="bg-white rounded-[60px] overflow-hidden shadow-2xl aspect-video lg:aspect-auto lg:h-full">
              <iframe
                title="Яндекс.Карта — Наро-Фоминск, Полубоярова 8"
                src={mapUrl}
                width="100%"
                height="100%"

                allowFullScreen=""
                loading="lazy"
                className="w-full h-full"
                style={{ minHeight: '400px' }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default SectionContact;